<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <h5 class="mb-0"><i class="fa fa-list mr-2" />Detail SPK</h5>
            <hr />
            <b-alert variant="danger" :show="spk.catatanBatal != null">
                <strong>DIBATALKAN</strong>
                <div>
                    <span style="white-space: pre-line">{{ spk.catatanBatal }}</span>
                </div>
                <div class="small">
                    {{ $helper.parseDate(spk.canceledAt) }}, {{ $helper.parseHourMinute(spk.canceledAt) }}
                </div>
            </b-alert>
            <b-row class="mb-2">
                <b-col md="4">
                    No. SPK
                    <h5>{{ spk.no }}</h5>
                </b-col>
                <b-col md="4">
                    Status
                    <h5>{{ spk.status.name }}</h5>
                </b-col>
                <b-col md="4">
                    Ex. Lokasi
                    <h5>{{ spk.exLokasi }}</h5>
                </b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col md="4">
                    Kategori & SN Unit
                    <h5 class="mb-0">{{ spk.sn }}</h5>
                    <div class="small">{{ spk.category }}</div>
                </b-col>
                <b-col md="4">
                    Tipe & Manu. Unit
                    <h5 class="mb-0">{{ spk.type }}</h5>
                    <div class="small">{{ spk.manufacturer }} {{ spk.search1 ? "- " + spk.search1 : "" }}</div>
                </b-col>
                <b-col md="4">
                    Pembuatan SPK
                    <h5 class="mb-0">{{ $helper.parseDate(spk.createdAt) }}, {{ $helper.parseHourMinute(spk.createdAt) }}</h5>
                    <div class="small">{{ spk.createdBy }}</div>
                </b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col md="4">
                    Jenis SPK
                    <h5 class="mb-0">
                        <span v-if="spk.workType == $enums.SpkWorkType.REPAIR">REPAIR</span>
                        <span v-else-if="spk.workType == $enums.SpkWorkType.QC">QC</span>
                        <span v-else-if="spk.workType == $enums.SpkWorkType.DISMANTLE">DISMANTLE</span>
                        <span v-else-if="spk.workType == $enums.SpkWorkType.ASSEMBLY">ASSEMBLY</span>
                        <span v-else>-</span>
                    </h5>
                </b-col>
                <b-col md="4">
                    Flow
                    <h5 class="mb-0">
                        <span v-if="spk.flow == $enums.SpkFlow.REPAIR">REPAIR</span>
                        <span v-else-if="spk.flow == $enums.SpkFlow.SCRAP">
                            <span v-if="spk.flowResult == $enums.SpkFlowResult.RTS">SCRAP - INOPERATIVE</span>
                            <span v-else-if="spk.flowResult == $enums.SpkFlowResult.JUNK">SCRAP - JUNK</span>
                        </span>
                        <span v-else-if="spk.flow == $enums.SpkFlow.QC">QC</span>
                        <span v-else-if="spk.flow == $enums.SpkFlow.DISMANTLE">
                            DISMANTLE
                            <span v-if="spk.flowResult == $enums.SpkFlowResult.RTS">- INOPERATIVE</span>
                            <span v-else-if="spk.flowResult == $enums.SpkFlowResult.JUNK">- JUNK</span>
                            <span v-else-if="spk.flowResult == $enums.SpkFlowResult.CONTINUE_ASSY">- LANJUT ASSEMBLY</span>
                        </span>
                        <span v-else-if="spk.flow == $enums.SpkFlow.ASSEMBLY">ASSEMBLY</span>
                        <span v-else>-</span>
                    </h5>
                </b-col>
            </b-row>
            <hr />
            <b-row class="mb-2">
                <b-col md="12">
                    <b>Catatan / Status</b>
                    <div>
                        <span style="white-space: pre-line">{{ spk.statusCatatan }}</span>
                    </div>
                </b-col>
            </b-row>
            <b-table bordered hover show-empty
                :items="items"
                :fields="fields"
                responsive class="my-3"
            >
                <template v-slot:cell(name)="row">
                    {{ row.item.name }}
                    <div class="small text-muted">{{ row.item.pic }}</div>
                </template>
                <template v-slot:cell(at)="row">
                    {{ $helper.parseDate(row.item.at) }}
                    <div class="small text-muted">{{ $helper.parseHourMinute(row.item.at) }}</div>
                </template>
                <template v-slot:cell(action)="row">
                    <b-button v-if="row.item.at != null && row.item.searchText != '-'" size="sm" variant="primary" @click="openModalCatatan(row.item.status, row.item)">
                        <i class="fa fa-search mr-2" />{{ row.item.searchText }}
                    </b-button>
                </template>
            </b-table>
            <div v-if="spk.rejections.length != 0" >
                <strong>Penolakan Laporan Hasil Kerja / Scrap Unit</strong>
                <b-table bordered hover show-empty
                    :items="rejectionItems"
                    :fields="rejectionFields"
                    responsive class="mb-4 mt-2"
                >
                    <template v-slot:cell(name)="row">
                        {{ row.item.by }}
                    </template>
                    <template v-slot:cell(at)="row">
                        {{ $helper.parseDate(row.item.at) }}
                        <div class="small text-muted">{{ $helper.parseHourMinute(row.item.at) }}</div>
                    </template>
                    <template v-slot:cell(reason)="row">
                        {{ row.item.reason }}
                    </template>
                    <template v-slot:cell(action)="row">
                        <b-button size="sm" variant="primary" @click="openModalBerkasPenyelesaian(row.item)">
                            <i class="fa fa-search mr-2" />Berkas Penyelesaian
                        </b-button>
                    </template>
                </b-table>
            </div>
            <div>
                <b-button v-if="isCancelAllowed" variant="danger" @click="$bvModal.show('modal-confirm-cancel')" class="mr-2">
                    <i class="fa fa-times mr-2" /> Batalkan SPK
                </b-button>
                <a v-if="isDownloadSpkAllowed" :href="$BASE_FILE_PATH + spk.pathSpk" download target="_blank" class="mr-2">
                    <b-button variant="primary">
                        <i class="fa fa-download mr-2" /> Download SPK
                    </b-button>
                </a>
                <span v-if="[$enums.SpkFlow.REPAIR, $enums.SpkFlow.QC, $enums.SpkFlow.DISMANTLE, $enums.SpkFlow.ASSEMBLY].includes(spk.flow)"><!-- Alur kerja Repair / QC / Dismantle / Assembly -->
                    <b-button v-if="spk.pathHasilKerja == null" variant="primary" disabled class="mr-2">
                        Tidak ada Bukti Hasil Kerja
                    </b-button>
                    <a v-else :href="$BASE_FILE_PATH + spk.pathHasilKerja" download target="_blank" class="mr-2">
                        <b-button variant="primary">
                            <i class="fa fa-download mr-2" /> Download Bukti Hasil Kerja
                        </b-button>
                    </a>
                </span>
                <span v-else-if="spk.flow == $enums.SpkFlow.SCRAP"><!-- Alur kerja Scrap -->
                    <b-button v-if="spk.pathScrapList == null" variant="primary" disabled class="mr-2">
                        Tidak ada List Sparepart Hasil Scrap
                    </b-button>
                    <a v-else :href="$BASE_FILE_PATH + spk.pathScrapList" download target="_blank" class="mr-2">
                        <b-button variant="primary">
                            <i class="fa fa-download mr-2" /> Download List Sparepart Hasil Scrap
                        </b-button>
                    </a>
                </span>
            </div>
            <div class="mt-2">
                <b-button v-if="isSetKirimAllowed" variant="success" @click="$bvModal.show('modal-set-kirim')">
                    <i class="fa fa-truck mr-2" /> Set Kirim ke Workshop
                </b-button>
                <b-button v-if="isSetDescKerjaAllowed" variant="success" @click="$bvModal.show('modal-set-desc-kerja')">
                    <i class="fa fa-pencil mr-2" /> Set Deskripsi Kerja
                </b-button>
                <div v-if="isSetRepairFinishedAllowed">
                    <b-button variant="success" @click="$bvModal.show('modal-set-repair-finished')">
                        <i class="fa fa-check mr-2" /> Set {{ $helper.workTypeLabel(spk.workType) }} Selesai
                    </b-button>
                    <b-button v-if="spk.workType == $enums.SpkWorkType.REPAIR" variant="danger" class="ml-2" @click="$bvModal.show('modal-set-scrap-list')">
                        <i class="fa fa-times mr-2" /> Ajukan Scrap / Salvage Unit
                    </b-button>
                    </div>
                <div v-if="isAccRepairAllowed">
                    <b-button variant="success" @click="$bvModal.show('modal-acc-repair')">
                        <i class="fa fa-check mr-2" />
                        <span v-if="isContinueAssembly">Approve dan Lanjutkan SPK Assembly</span>
                        <span v-else>Approve {{ $helper.workTypeLabel(spk.workType) }} Selesai</span>
                    </b-button>
                    <b-button class="ml-2" variant="danger" @click="$bvModal.show('modal-reject-repair')">
                        <i class="fa fa-times mr-2" /> Reject {{ $helper.workTypeLabel(spk.workType) }} Selesai
                    </b-button>
                </div>
                <div v-if="isAccScrapListAllowed">
                    <b-button variant="success" @click="$bvModal.show('modal-acc-scrap')">
                        <i class="fa fa-check mr-2" /> Approve Scrap
                    </b-button>
                    <b-button class="ml-2" variant="danger" @click="$bvModal.show('modal-reject-scrap')">
                        <i class="fa fa-times mr-2" /> Reject Scrap
                    </b-button>
                </div>
                <b-button v-if="isTakeScrapAllowed" variant="success" @click="$bvModal.show('modal-take-scrap')">
                    <i class="fa fa-truck mr-2" /> Nyatakan Sparepart Diterima
                </b-button>
                <b-button v-if="isReturnAllowed" variant="success" @click="$bvModal.show('modal-return')">
                    <i class="fa fa-truck mr-2" /> Kirim Kembali ke Warehouse
                </b-button>
            </div>
        </b-card>
        <b-card v-if="spk.status.id >= 5 && spk.workType != $enums.SpkWorkType.DISMANTLE">
            <div class="d-flex align-items-center justify-content-between">
                <h5 class="mb-0"><i class="fa fa-list mr-2" />BOM</h5>
                <div class="text-right">
                    <b-button v-if="isAddBomAllowed" variant="dark" @click="$bvModal.show('modal-new-bom')">
                        <i class="fa fa-plus mr-2" />BOM Baru
                    </b-button>
                </div>
            </div>
            <hr />
            <div v-if="spk.boms.length == 0">Tidak ada BOM</div>
            <b-row v-else>
                <b-col v-for="item in spk.boms" v-bind:key="item.id" md="4">
                    <b-card>
                        <strong>BOM #{{ item.no }}</strong>
                        <div>No. BOM: <strong>{{ item.nomorBom }}</strong></div>
                        <hr class="my-2" />
                        <strong>Pengajuan</strong>
                        <div>{{ item.createdBy }}</div>
                        <div>{{ $helper.parseDate(item.createdAt) }}, {{ $helper.parseHourMinute(item.createdAt) }}</div>
                        <a :href="$BASE_FILE_PATH + item.pathBom" download target="_blank">
                            <b-button class="mt-2 mb-2" size="sm" variant="primary">
                                <i class="fa fa-download mr-2" />Download BOM
                            </b-button>
                        </a>
                        <div v-if="item.approvedBy != null">
                            <hr class="my-2" />
                            <strong>Approval</strong>
                            <div>{{ item.approvedBy }}</div>
                            <div>{{ $helper.parseDate(item.approvedAt) }}, {{ $helper.parseHourMinute(item.approvedAt) }}</div>
                            <a v-if="item.pathRevisi != null" :href="$BASE_FILE_PATH + item.pathRevisi" download target="_blank">
                                <b-button class="mt-2 mb-2" size="sm" variant="primary">
                                    <i class="fa fa-download mr-2" />Download Revisi SPK
                                </b-button>
                            </a>
                        </div>
                        <div v-if="item.readyBy != null">
                            <hr class="my-2" />
                            <strong>Ready Pick Up</strong>
                            <div>{{ item.readyBy }}</div>
                            <div>{{ $helper.parseDate(item.readyAt) }}, {{ $helper.parseHourMinute(item.readyAt) }}</div>
                        </div>
                        <div v-if="item.serahTerimaBy != null">
                            <hr class="my-2" />
                            <strong>Serah Terima</strong>
                            <div>{{ item.serahTerimaBy }}</div>
                            <div>{{ $helper.parseDate(item.serahTerimaAt) }}, {{ $helper.parseHourMinute(item.serahTerimaAt) }}</div>
                            <div>No. DO: <strong>{{ item.nomorDo }}</strong></div>
                        </div>
                        <div v-if="item.rejectedBy != null">
                            <hr class="my-2" />
                            <strong>Rejected / Ditolak</strong>
                            <div>Alasan Penolakan:<br />{{ item.rejectReason }}</div>
                            <div class="mt-4">{{ item.rejectedBy }}</div>
                            <div>{{ $helper.parseDate(item.rejectedAt) }}, {{ $helper.parseHourMinute(item.rejectedAt) }}</div>
                        </div>
                        <div v-if="item.status == $enums.BomStatus.NEW && isApproveRejectBomAllowed">
                            <hr class="mt-2 mb-3">
                            <b-button variant="success" @click="prepareBomModal(item, 'modal-approve-bom')">
                                <i class="fa fa-check mr-2" /> Approve BOM
                            </b-button>
                            <br />
                            <b-button class="mt-2" variant="danger" @click="prepareBomModal(item, 'modal-reject-bom')">
                                <i class="fa fa-times mr-2" /> Reject BOM
                            </b-button>
                        </div>
                        <div v-else-if="item.status == $enums.BomStatus.APPROVED && isSetSparepartAllowed">
                            <hr class="mt-2 mb-3">
                            <b-button variant="success" @click="prepareBomModal(item, 'modal-set-ready-bom')">
                                <i class="fa fa-check mr-2" /> Set Ready
                            </b-button>
                        </div>
                        <div v-else-if="item.status == $enums.BomStatus.READY_FOR_PICKUP && isSetSparepartAllowed">
                            <hr class="mt-2 mb-4">
                            <b-button variant="success" @click="prepareBomModal(item, 'modal-set-sparepart')">
                                <i class="fa fa-truck mr-2" /> Set Serah Terima
                            </b-button>
                        </div>
                    </b-card>
                </b-col>
            </b-row>
        </b-card>
        <b-card v-if="spk.status.id >= 5 && spk.workType != $enums.SpkWorkType.DISMANTLE">
            <div class="d-flex align-items-center justify-content-between">
                <h5 class="mb-0"><i class="fa fa-list mr-2" />SPB</h5>
                <div class="text-right">
                    <b-button v-if="isAddSpbAllowed" variant="dark" @click="$bvModal.show('modal-new-spb')">
                        <i class="fa fa-plus mr-2" />SPB Baru
                    </b-button>
                </div>
            </div>
            <hr />
            <div v-if="spk.spbs.length == 0">Tidak ada SPB</div>
            <b-row v-else>
                <b-col v-for="item in spk.spbs" v-bind:key="item.id" md="4">
                    <b-card>
                        <strong>SPB #{{ item.no }}</strong>
                        <div>No. SPB: <strong>{{ item.nomorSpb }}</strong></div>
                        <hr class="my-2" />
                        <strong>Pengajuan</strong>
                        <div>{{ item.createdBy }}</div>
                        <div>{{ $helper.parseDate(item.createdAt) }}, {{ $helper.parseHourMinute(item.createdAt) }}</div>
                        <a :href="$BASE_FILE_PATH + item.pathSpb" download target="_blank">
                            <b-button class="mt-2 mb-2" size="sm" variant="primary">
                                <i class="fa fa-download mr-2" />Download SPB
                            </b-button>
                        </a>
                        <div v-if="item.approvedBy != null">
                            <hr class="my-2" />
                            <strong>Approval</strong>
                            <div>{{ item.approvedBy }}</div>
                            <div>{{ $helper.parseDate(item.approvedAt) }}, {{ $helper.parseHourMinute(item.approvedAt) }}</div>
                        </div>
                        <div v-if="item.roSubmittedBy != null">
                            <hr class="my-2" />
                            <strong>Pembuatan RO</strong>
                            <div>{{ item.roSubmittedBy }}</div>
                            <div>{{ $helper.parseDate(item.roSubmittedAt) }}, {{ $helper.parseHourMinute(item.roSubmittedAt) }}</div>
                            <div>No. RO: <strong>{{ item.nomorRo }}</strong></div>
                            <a :href="$BASE_FILE_PATH + item.pathRo" download target="_blank">
                                <b-button class="mt-2 mb-2" size="sm" variant="primary">
                                    <i class="fa fa-download mr-2" />Download RO
                                </b-button>
                            </a>
                        </div>
                        <div v-if="item.readyBy != null">
                            <hr class="my-2" />
                            <strong>Ready Pick Up</strong>
                            <div>{{ item.readyBy }}</div>
                            <div>{{ $helper.parseDate(item.readyAt) }}, {{ $helper.parseHourMinute(item.readyAt) }}</div>
                        </div>
                        <div v-if="item.doneBy != null">
                            <hr class="my-2" />
                            <strong>Serah Terima</strong>
                            <div>{{ item.doneBy }}</div>
                            <div>{{ $helper.parseDate(item.doneAt) }}, {{ $helper.parseHourMinute(item.doneAt) }}</div>
                            <div>No. DO: <strong>{{ item.nomorDo }}</strong></div>
                        </div>
                        <div v-if="item.rejectedBy != null">
                            <hr class="my-2" />
                            <strong>Rejected / Ditolak</strong>
                            <div>Alasan Penolakan:<br />{{ item.rejectReason }}</div>
                            <div class="mt-4">{{ item.rejectedBy }}</div>
                            <div>{{ $helper.parseDate(item.rejectedAt) }}, {{ $helper.parseHourMinute(item.rejectedAt) }}</div>
                        </div>
                        <div v-if="item.status == $enums.SpbStatus.NEW && isApproveRejectSpbAllowed">
                            <hr class="mt-2 mb-3">
                            <b-button variant="success" @click="prepareSpbModal(item, 'modal-approve-spb')">
                                <i class="fa fa-check mr-2" /> Approve SPB
                            </b-button>
                            <br />
                            <b-button class="mt-2" variant="danger" @click="prepareSpbModal(item, 'modal-reject-spb')">
                                <i class="fa fa-times mr-2" /> Reject SPB
                            </b-button>
                        </div>
                        <div v-else-if="item.status == $enums.SpbStatus.APPROVED && isUploadRoSpbAllowed">
                            <hr class="mt-2 mb-3">
                            <b-button variant="success" @click="prepareSpbModal(item, 'modal-upload-ro-spb')">
                                <i class="fa fa-upload mr-2" /> Upload RO
                            </b-button>
                            <b-button variant="danger" class="ml-2" @click="prepareSpbModal(item, 'modal-reject-spb')">
                                <i class="fa fa-times mr-2" /> Reject
                            </b-button>
                        </div>
                        <div v-else-if="item.status == $enums.SpbStatus.RO_SUBMITTED && isSetReadySpbAllowed">
                            <hr class="mt-2 mb-3">
                            <b-button variant="success" @click="prepareSpbModal(item, 'modal-set-ready-spb')">
                                <i class="fa fa-check mr-2" /> Set Ready
                            </b-button>
                        </div>
                        <div v-else-if="item.status == $enums.SpbStatus.READY_FOR_PICKUP && isSetDoneSpbAllowed">
                            <hr class="mt-2 mb-4">
                            <b-button variant="success" @click="prepareSpbModal(item, 'modal-set-done-spb')">
                                <i class="fa fa-truck mr-2" /> Set Serah Terima
                            </b-button>
                        </div>
                    </b-card>
                </b-col>
            </b-row>
        </b-card>
        <b-card>
            <div class="d-flex align-items-center justify-content-between">
                <h5 class="mb-0"><i class="fa fa-file mr-2" />Berkas / Catatan</h5>
                <div class="text-right">
                    <b-button v-if="isAddDocumentAllowed" variant="dark" @click="$bvModal.show('modal-new-document')">
                        <i class="fa fa-plus mr-2" />Berkas Baru
                    </b-button>
                </div>
            </div>
            <hr />
            <div v-if="spk.docs.length == 0">Tidak ada berkas / catatan</div>
            <b-table v-else bordered hover show-empty
                :items="docItems"
                :fields="docFields"
                responsive class="my-3"
            >
                <template v-slot:cell(name)="row">
                    {{ row.item.createdBy }}
                </template>
                <template v-slot:cell(at)="row">
                    {{ $helper.parseDate(row.item.createdAt) }}
                    <div class="small text-muted">{{ $helper.parseHourMinute(row.item.createdAt) }}</div>
                </template>
                <template v-slot:cell(notes)="row">
                    {{ row.item.notes }}
                </template>
                <template v-slot:cell(action)="row">
                    <a v-if="row.item.path != null" :href="$BASE_FILE_PATH + row.item.path" download target="_blank">
                        <b-button size="sm" variant="primary">
                            <i class="fa fa-download mr-2" />Download Berkas
                        </b-button>
                    </a>
                    <b-button v-else size="sm" variant="dark" disabled>
                        Tidak ada berkas
                    </b-button>
                </template>
            </b-table>
        </b-card>
        <SpkModals :id="$route.params.id" :bom="activeBom" :spb="activeSpb" :rejection="activeRejection" :work-type="spk.workType" :flow-result="spk.flowResult"
            @refresh="doRefresh"
            @new-bom="onNewBom"
            @bom-updated="onBomUpdated"
            @spb-updated="onSpbUpdated"
            @new-doc="onNewDoc"
            @new-spb="onNewSpb"
        />
        <b-modal id="modal-catatan" :title="modalCatatanTitle" centered hide-footer>
            <div v-if="!isGettingCatatan">
                <span style="white-space: pre-line">{{ modalCatatanContent }}</span>
                <div class="mt-4 small">
                    {{ modalCatatanItem.by }} - {{ $helper.parseDate(modalCatatanItem.at) }}, {{ $helper.parseHourMinute(modalCatatanItem.at) }}
                </div>
            </div>
            <div v-else>
                Mengambil data, mohon menunggu...
            </div>
        </b-modal>
    </div>
</template>

<script>
import SpkModals from './SpkDetailModals'

export default {
    name: 'spk-detail',
    components: { SpkModals },
    data() {
        return {

            initStatus: 0,
            isSubmitting: false,
            isGettingCatatan: false,

            spk: { status: { id: 0, name: "" }},
            items: [],
            roleId: -1,
            activeBom: {},
            activeRejection: {},
            activeSpb: {},

            modalCatatanTitle: "",
            modalCatatanContent: "",
            modalCatatanItem: {},

            fields: [
                { key: "name", label: "Tahap & PIC" },
                { key: "at", label: "Eksekusi pada" },
                { key: "by", label: "Eksekutor" },
                { key: "action", label: "Catatan"},
            ],

            rejectionItems: [],
            rejectionFields: [
                { key: "name", label: "Penolakan oleh" },
                { key: "at", label: "Penolakan pada" },
                { key: "reason", label: "Alasan Penolakan" },
                { key: "action", label: "Berkas" }
            ],

            docItems: [],
            docFields: [
                { key: "name", label: "Ditambahkan oleh" },
                { key: "at", label: "Ditambahkan pada" },
                { key: "notes", label: "Catatan" },
                { key: "action", label: "Aksi" }
            ],

            // list: [
            //     { step: 1, name: "Pengiriman Unit ke Workshop", pic: "LOGISTIK" },
            //     { step: 2, name: "Penulisan Deskripsi Kerja", pic: "WORKSHOP", searchText: "Deskripsi Kerja" },
            //     { step: 3, name: "Laporan Penyelesaian Pekerjaan", pic: "WORKSHOP", searchText: "Catatan" },
            //     { step: 4, name: "Approval Pengerjaan Perbaikan", pic: "PPIC", searchText: "Catatan" },
            //     { step: 5, name: "Pengiriman Kembali ke Warehouse", pic: "LOGISTIK" }
            //     // { step: 2, name: "Penulisan Deskripsi Kerja dan BOM", pic: "WORKSHOP", searchText: "Deskripsi Kerja" },
            //     // { step: 3, name: "Approval Deskripsi Kerja dan BOM", pic: "PPIC", searchText: "Revisi Deskripsi Kerja" },
            //     // { step: 4, name: "Serah Terima Sparepart BOM", pic: "LOGISTIK", searchText: "Nomor DO & Catatan" },
            //     // { step: 5, name: "Pengerjaan Perbaikan", pic: "WORKSHOP", searchText: "Catatan" },
            //     // { step: 6, name: "Approval Pengerjaan Perbaikan", pic: "PPIC", searchText: "Catatan" },
            //     // { step: 7, name: "Pengiriman Kembali ke Warehouse", pic: "LOGISTIK" },
            // ]

        }
    },
    computed: {

        isCancelAllowed() {
            return this.spk.status.id == 1 && [0, 1, 7, 8].includes(this.roleId)
        },

        isDownloadSpkAllowed() {
            return [0, 1, 7, 8, 10].includes(this.roleId)
        },

        isSetKirimAllowed() {
            return this.spk.status.id == 1 && [0, 1, 8].includes(this.roleId)
        },

        isSetDescKerjaAllowed() {
            return this.spk.status.id == 2 && [0, 5, 6].includes(this.roleId)
        },

        isApproveRejectBomAllowed() {
            return [0, 10].includes(this.roleId)
        },

        isSetSparepartAllowed() {
            return [0, 1, 8].includes(this.roleId)
        },

        isContinueAssembly() {
            return this.spk.workType == this.$enums.SpkWorkType.DISMANTLE
                && this.spk.flowResult == this.$enums.SpkFlowResult.CONTINUE_ASSY
        },

        isSetRepairFinishedAllowed() {
            return this.spk.status.id == 5 && [0, 5, 6].includes(this.roleId)
        },

        isAccRepairAllowed() {
            return this.spk.status.id == 6 && [0, 10].includes(this.roleId)
        },

        isReturnAllowed() {
            return this.spk.status.id == 7 && [0, 1, 8].includes(this.roleId)
        },

        isAddBomAllowed() {
            return this.spk.status.id == 5 && [0, 7, 10].includes(this.roleId)
        },

        isAddDocumentAllowed() {
            return [0, 7, 10].includes(this.roleId)
        },

        isAddSpbAllowed() {
            return this.spk.status.id == 5 && [0, 7, 10].includes(this.roleId)
        },

        isApproveRejectSpbAllowed() {
            return [0, 10].includes(this.roleId)
        },

        isUploadRoSpbAllowed() {
            return [0, 1, 8].includes(this.roleId)
        },

        isSetReadySpbAllowed() {
            return [0, 1, 8].includes(this.roleId)
        },

        isSetDoneSpbAllowed() {
            return [0, 1, 8].includes(this.roleId)
        },

        isAccScrapListAllowed() {
            return this.spk.status.id == 9 && [0, 10].includes(this.roleId)
        },

        isTakeScrapAllowed() {
            return this.spk.status.id == 10 && [0, 1, 8].includes(this.roleId)
        }

    },
    methods: {

        init() {

            this.initStatus = 0

            Promise.all([this.getDetail()]).then(res => {
                this.initStatus = 1
            })
            .catch(error => {
                this.initStatus = 0
            })

        },

        getDetail() {

            return this.$axios.get("spk/" + this.$route.params.id).then(res => {
                let entries = res.data.entries

                this.spk = res.data
                this.items = entries
                this.rejectionItems = res.data.rejections
                this.docItems = res.data.docs
            })
            .catch(error => this.$helper.parseError(this, error))

        },

        doRefresh() {
            this.init()
        },

        onNewBom(bom) {
            this.spk.boms.push(bom)
        },

        onNewDoc(doc) {
            this.spk.docs.push(doc)
        },

        onNewSpb(spb) {
            this.spk.spbs.push(spb)
        },

        onBomUpdated(bom) {
            this.activeBom.approvedAt = bom.approvedAt
            this.activeBom.approvedBy = bom.approvedBy
            this.activeBom.serahTerimaAt = bom.serahTerimaAt
            this.activeBom.serahTerimaBy = bom.serahTerimaBy
            this.activeBom.readyAt = bom.readyAt
            this.activeBom.readyBy = bom.readyBy
            this.activeBom.pathRevisi = bom.pathRevisi
            this.activeBom.nomorDo = bom.nomorDo
            this.activeBom.rejectedAt = bom.rejectedAt
            this.activeBom.rejectedBy = bom.rejectedBy
            this.activeBom.rejectReason = bom.rejectReason
            this.activeBom.status = bom.status
        },

        onSpbUpdated(spb) {
            this.activeSpb.approvedAt = spb.approvedAt
            this.activeSpb.approvedBy = spb.approvedBy
            this.activeSpb.doneAt = spb.doneAt
            this.activeSpb.doneBy = spb.doneBy
            this.activeSpb.readyAt = spb.readyAt
            this.activeSpb.readyBy = spb.readyBy
            this.activeSpb.roSubmittedAt = spb.roSubmittedAt
            this.activeSpb.roSubmittedBy = spb.roSubmittedBy
            this.activeSpb.rejectedAt = spb.rejectedAt
            this.activeSpb.rejectedBy = spb.rejectedBy
            this.activeSpb.rejectReason = spb.rejectReason
            this.activeSpb.status = spb.status
            this.activeSpb.nomorSpb = spb.nomorSpb
            this.activeSpb.nomorDo = spb.nomorDo
            this.activeSpb.nomorRo = spb.nomorRo
            this.activeSpb.pathRo = spb.pathRo
        },

        prepareBomModal(bom, modal) {
            this.activeBom = bom
            this.$bvModal.show(modal)
        },

        prepareSpbModal(spb, modal) {
            this.activeSpb = spb
            this.$bvModal.show(modal)
        },

        openModalCatatan(index, item) {

            this.modalCatatanItem = item
            this.modalCatatanTitle = item.name
            this.$bvModal.show("modal-catatan")

            this.isGettingCatatan = true
            this.$axios.get(`spk/catatan/${this.$route.params.id}/${index}`).then(res => {
                this.modalCatatanContent = res.data.name
            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isGettingCatatan = false)

        },

        openModalBerkasPenyelesaian(item) {
            this.activeRejection = item
            this.$bvModal.show("modal-berkas-penyelesaian")
        }

    },
    created() {
        this.init()
        this.roleId = Number(localStorage.getItem("roleId"))
    }
}
</script>
